// extracted by mini-css-extract-plugin
export default {"dialog-confirm__children":"DialogConfirm_dialog-confirm__children__TxPLM","dialog-confirm__title":"DialogConfirm_dialog-confirm__title__L3CSO"};